import {Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PinchZoomComponent} from "@meddv/ngx-pinch-zoom";

@Component({
  selector: 'app-header-image',
  imports: [CommonModule, PinchZoomComponent],
  templateUrl: './header-image.component.html',
  styleUrl: './header-image.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HeaderImageComponent implements OnInit {

  images: string[] = [];

  @Input() src: undefined | null | string = '';
  @Input() alt: string = '';
  @Input() additionalItems: string[] = [];
  @Input() cardHeaderImage: boolean = false;
  @Input() fullHeight: boolean;

  @ViewChild('swiper') swiperRef: ElementRef | undefined;

  ngOnInit() {
    if (this.src) {
      this.images.push(this.src);
    }

    if (this.additionalItems.length > 0) {
      this.images = this.images.concat(this.additionalItems);
      this.images = Array.from(new Set(this.images));
    }

    console.log(`${this.constructor.name} initialized`, this.images);
  }
}
